import axios from 'axios';
import errorMessage from 'Store/actions/errorMessage';
import {
  GET_HORSE_RACE_AGF_GAME_SELECT,
  GET_HORSE_RACE_AGF_GAME_SELECT_SUCCESS,
  GET_HORSE_RACE_AGF_GAME_SELECT_FAILURE,
  GET_HORSE_RACE_AGF_LIST,
  GET_HORSE_RACE_AGF_LIST_SUCCESS,
  GET_HORSE_RACE_AGF_LIST_FAILURE,
  GET_HORSE_RACE_AGF_HIPPODROMES,
  GET_HORSE_RACE_AGF_HIPPODROMES_SUCCESS,
  GET_HORSE_RACE_AGF_HIPPODROMES_FAILURE,
  SET_SELECTED_AGF_HIPPODROME,
  SET_SELECTED_AGF_SIX_PICK_ORDER,
  SET_SELECTED_AGF_LEG
} from 'Store/constants';
import { agfListMapper, agfSelectableListMapper, hippodromesMapper, isStrictHippdrome } from 'Utils/horseRacesNameMapper';
import { catchTJKError } from 'Utils/catchTJKError';
import { navigateWithParams } from 'Utils/horseRacingRouteHelper';
import ProjectConfig from 'ProjectConfig';

export const getAGFHippodromes = defaultHippodrome => async dispatch => {
  try {
    dispatch({
      type: GET_HORSE_RACE_AGF_HIPPODROMES,
    });
  
    const date = new Date().getTime();
    const apiUrl = ProjectConfig.API_GATEWAY + '/mobile/tjk/hippodromes/agf';
    const res = await axios.get(apiUrl, { params: { raceDate: date } });

    const isStrict = isStrictHippdrome(defaultHippodrome?.key);

    catchTJKError(res.data);

    const payload = hippodromesMapper(res.data.body);

    const isDefaultexist = payload.find(e => e.key === defaultHippodrome?.key);
    
    if (isStrict && !isDefaultexist) { // zorunlu hipodromlardan biri ise ve bu hipodrome bugun yoksa hata sayfası göster
      throw ({ message: true, strictHippodromeError: true });
    }

    if (defaultHippodrome && !isDefaultexist) { // belirli bir hipodromu açmaya çalısıp acamadiysa, urli düzelt
      navigateWithParams({ type: 'replace', params: '' });
    }

    dispatch(setSelectedAGFHippodrome(isDefaultexist || payload.find(e => e.isSelected) || payload[0]));
    dispatch({
      type: GET_HORSE_RACE_AGF_HIPPODROMES_SUCCESS,
      payload: payload
    });

  } catch (e) {
    dispatch({
      type: GET_HORSE_RACE_AGF_HIPPODROMES_FAILURE,
      payload: e.response?.data || (e.message ? e : errorMessage),
    });
  }
};

export const setSelectedAGFHippodrome = hippodrome => async dispatch => {
  dispatch({
    type: SET_SELECTED_AGF_HIPPODROME,
    payload: hippodrome
  });
  dispatch(getAgfGameSelect(hippodrome.cardId));
};

export const setSelectedSixPickOrder = sixPickOrder => async dispatch => {
  dispatch({
    type: SET_SELECTED_AGF_SIX_PICK_ORDER,
    payload: sixPickOrder
  });
};

export const setSelectedAGFLeg = legItem => async dispatch => {
  dispatch({
    type: SET_SELECTED_AGF_LEG,
    payload: { ...legItem, agfRaceInfoList: legItem.agfRaceInfoList.sort((a, b) => a.agfRank - b.agfRank) }
  });
};

export const getAgfGameSelect = cardId => async dispatch => {
  try {
    dispatch({
      type: GET_HORSE_RACE_AGF_GAME_SELECT
    });

    const apiUrl = ProjectConfig.API_GATEWAY + `/mobile/tjk/agf/${cardId}`;
    const res = await axios.get(apiUrl);

    catchTJKError(res.data);

    const payload = agfSelectableListMapper(res.data.body);
    dispatch({
      type: GET_HORSE_RACE_AGF_GAME_SELECT_SUCCESS,
      payload
    });

    dispatch(getAgfList(cardId, payload.agfSelectableList[0].value));

  } catch (e) {
    dispatch({
      type: GET_HORSE_RACE_AGF_GAME_SELECT_FAILURE,
      payload: e.response?.data || (e.message ? e : errorMessage),
    });
  }
};

export const getAgfList = (cardId, selectedRace) => async dispatch => {
  try {
    dispatch({
      type: GET_HORSE_RACE_AGF_LIST
    });
  
    const apiUrl = ProjectConfig.API_GATEWAY + `/mobile/tjk/agf/${cardId}/selectable?selectedRace=${selectedRace}`;
    const res = await axios.get(apiUrl);

    catchTJKError(res.data);

    const payload = agfListMapper(res.data.body);

    dispatch({
      type: GET_HORSE_RACE_AGF_LIST_SUCCESS,
      payload
    });
    dispatch(setSelectedAGFLeg(payload.agfList[0]));
  
  } catch (e) {
    dispatch({
      type: GET_HORSE_RACE_AGF_LIST_FAILURE,
      payload: e.response?.data || (e.message ? e : errorMessage),
    });
  }
};